import AddRolePermission from "../../Components/Modals/AddRolePermission";
import Table from "../../Components/Table";
import { deleteRolePermissionById, getRolePermission } from "../../Services/MasterService";

const RolePermission = () => {
    const columns = [
        {
            label: "Role",
            value: "role_name"
        },
        {
            label: "Permission",
            value: "permission_name"
        },
        {
            label: "Resource",
            value: "resource"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddRolePermission data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getRolePermission}
            columns={columns}
            title={"Roles And Permissions Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteRolePermissionById}
        />
    );
}

export default RolePermission;